<template>
  <div class="w3-white w3-border" v-show="aberto">
    <div class="w3-cell-row acordion" @click="acordion1 = !acordion1">
      <div class="w3-cell">
        <span class="w3-small"><b>Abrir Caixa</b></span>
      </div>
      <div class="w3-cell w3-right-align" style="width: 50px">
        <i class="fa" :class="acordion1 ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>
    </div>
    <div class="w3-padding w3-border-bottom w3-padding-16 w3-small" v-show="acordion1">
      <p>
        Para adicionar uma nova venda, acesse o menu <b>Módulo PDV</b> > <b>PDV</b> e clique em:
      </p>
      <p class="w3-margin-top">
        <span class="primary w3-padding w3-round">Nova Venda</span>
      </p>
      <p>
        Escolha o tipo:<br>
      </p>
      <div class="w3-cell-row primary w3-center w3-round" style="width: 300px">
        <div class="w3-cell w3-padding w3-border-right" style="width: 100px">Mesa</div>
        <div class="w3-cell w3-padding w3-border-right" style="width: 100px">Delivery</div>
        <div class="w3-cell w3-padding" style="width: 100px">Comanda</div>
      </div>
      <div class="w3-margin-top">
        <div><b>*Mesa</b>: Mesas numeradas do estabelecimento.</div>
        <div><b>*Delivery</b>: Vendas para clientes que vão consumir fora do estabelecimento.</div>
        <div><b>*Comanda</b>: Vinculação com comandas físicas usando númerações ou o código de barras da comanda.</div>
      </div>
      <p>
        E se necessário, poderá ser adicionado uma observação (Campo livre).
        Como por exemplo: <br>
        <b>"Nome da pessoa"</b>,
        anotações para outros funcionarios: <b>"Cliente gosta de cerveja artesanal"</b>, entre outros.
      </p>
    </div>
    <div class="w3-cell-row acordion">
      <div class="w3-cell">
        <span class="w3-small"><b>Fechar Caixa</b></span>
      </div>
      <div class="w3-cell w3-right-align" style="width: 50px">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>
    <div class="w3-cell-row acordion">
      <div class="w3-cell">
        <span class="w3-small"><b>Conferir Caixa</b></span>
      </div>
      <div class="w3-cell w3-right-align" style="width: 50px">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "PdvNovaVenda",
        props: {
          aberto: ''
        },
        data() {
          return {
            acordion1: true
          }
        }
    }
</script>

<style scoped>
  .fechado {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/wiki/acordion/WikiCaixa.vue